module.exports = __webpack_public_path__ + "img/software-thumb-3.c4f6a46b.png";